import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../context/PermissionsContext';

export const ProtectedRoute = ({ children, requiredPermission, requiredModule }) => {
  const { hasPermission, hasModuleAccess, loading, accessType, role } = usePermissions();
  const isLoggedIn = localStorage.getItem('isAdminLoggedIn') === 'true';

  // Show loading state
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading permissions...
      </div>
    );
  }

  // Check if user is logged in
  if (!isLoggedIn) {
    return <Navigate to="/admin-login" replace />;
  }

  // If Administrator role or full access (subAdmin), allow all routes
  if (role === 'Administrator' || accessType === 'subAdmin' || accessType === 'full') {
    return children;
  }

  // Check specific permission if provided
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return (
      <div style={{
        padding: '40px',
        textAlign: 'center',
        fontSize: '18px',
        color: '#ef4444'
      }}>
        <h2>Access Denied</h2>
        <p>You don't have permission to access this page.</p>
        <p style={{ fontSize: '14px', color: '#666', marginTop: '10px' }}>
          Required permission: {requiredPermission}
        </p>
      </div>
    );
  }

  // Check module access if provided
  if (requiredModule && !hasModuleAccess(requiredModule)) {
    return (
      <div style={{
        padding: '40px',
        textAlign: 'center',
        fontSize: '18px',
        color: '#ef4444'
      }}>
        <h2>Access Denied</h2>
        <p>You don't have permission to access this module.</p>
        <p style={{ fontSize: '14px', color: '#666', marginTop: '10px' }}>
          Required module: {requiredModule}
        </p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
